/* globals TimelineMax, TweenMax */
define('navigation-transition',['helpers', 'pubsub'], function(helpers, PubSub) {

    var transition,
        root = document.documentElement,
        hiddenCSS = 'is-completed',
        loadingCSS = 'is-loading',
        postfix = '';

    function getLastTimeline(props) {
        var max = 0,
            total = 0,
            timeline = '',
            getTotal = function(duration, from, to) {
                return (((duration) ? parseFloat(duration) : 0) + ((from) ? parseFloat(from) : 0) + ((to) ? parseFloat(to) : 0)) * 1000;
            };

        props.forEach(function(prop) {
            total = getTotal(prop.duration, prop.paramsFrom.delay, prop.paramsTo.delay);

            if (total > max) {
                max = total;
                timeline = prop.element;
            }
        });

        return timeline;
    }

    function Transition(options) {
        options = options || {};

        this.duration = options.duration || 150;

        this.transition = (options.transition) ? options.transition.toLowerCase() : 'css';

        this.transitionIn = '';

        this.params = options.transitionparams || {};

        this.isLoading = false;
    }

    Transition.prototype.initLoading = function(swiping, dir, transition, updateVM) {
        var _this = this;

        _this.transitionIn = transition || _this.transition;

        dir = (dir) ? dir.toLowerCase() : '';

        postfix = ((dir === 'back') ? 'Back' : 'Forward') + ((swiping) ? 'Swipe' : '');

        if (_this.isLoading) {
            return;
        }

        _this.isLoading = true;

        switch(_this.transitionIn) {
        case 'css':

            PubSub.publish('transition-out-init', {});

            root.classList.add(loadingCSS);

            setTimeout(function() {

                PubSub.publish('transition-out-complete', {});
                updateVM();
                helpers.layout.scrollTop();

            }, _this.duration/2);

            break;
        case 'tweenmax':

            require(['gsap'], function() {
                var prop = 'transitionOut' + postfix,
                    last = '',
                    timelines = {};

                PubSub.publish('transition-out-init', {});

                if (!_this.params[prop]) {
                    PubSub.publish('transition-out-complete', {});
                    updateVM();
                    helpers.layout.scrollTop();
                    return;
                }

                last = getLastTimeline(_this.params[prop]);

                _this.params[prop].forEach(function(data) {
                    if (!timelines[data.element]) {
                        timelines[data.element] = (last === data.element) ? new TimelineMax({onComplete: function() {
                            root.classList.add(hiddenCSS);
                            PubSub.publish('transition-out-complete', {});
                            updateVM();
                            helpers.layout.scrollTop();
                        }}) : new TimelineMax();
                    }

                    timelines[data.element].add(TweenMax.fromTo(data.element, data.duration, data.paramsFrom, data.paramsTo));
                });

            });

            break;
        default:
            PubSub.publish('transition-out-init', {});

            PubSub.publish('transition-out-complete', {});

            updateVM();
            helpers.layout.scrollTop();
        }
    };

    Transition.prototype.completeLoading = function() {
        var _this = this;

        if (!_this.isLoading) {
            return;
        }

        switch(_this.transitionIn) {
        case 'css':

            PubSub.publish('transition-in-init', {});

            root.classList.remove(loadingCSS);

            setTimeout(function() {
                _this.isLoading = false;
                PubSub.publish('transition-in-complete', {});
            }, _this.duration);

            break;
        case 'tweenmax':

            require(['gsap'], function() {
                var prop = 'transitionIn' + postfix,
                    last = '',
                    timelines = {};

                PubSub.publish('transition-in-init', {});

                if (!_this.params[prop]) {
                    _this.isLoading = false;
                    PubSub.publish('transition-in-complete', {});
                    return;
                }

                last = getLastTimeline(_this.params[prop]);

                _this.params[prop].forEach(function(data) {
                    if (!timelines[data.element]) {
                        timelines[data.element] = (last === data.element) ? new TimelineMax({
                            onStart: function() {
                                root.classList.remove(hiddenCSS);
                            },
                            onComplete: function() {
                                _this.isLoading = false;
                                PubSub.publish('transition-in-complete', {});
                            }
                        }) : new TimelineMax();
                    }

                    timelines[data.element].add(TweenMax.fromTo(data.element, data.duration, data.paramsFrom, data.paramsTo));
                });
            });

            break;
        default:
            PubSub.publish('transition-in-init', {});

            _this.isLoading = false;

            PubSub.publish('transition-in-complete', {});
        }
    };

    return function(options) {

        if (!transition) {
            transition = new Transition(options);

            PubSub.subscribe('page-load-complete', function() {
                transition.completeLoading();
            });
        }

        return transition;
    };

});

